/* src/components/landing/LpHowItWorks.jsx */
import React from 'react';
import { STEPS } from '../../data/landing';

export default function LpHowItWorks({ addReveal, revealStyle }) {
  return (
    <section id="como-funciona" className="s-pad" style={{ padding: '120px 0', background: 'var(--primary)', color: '#fff', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: -200, left: '50%', transform: 'translateX(-50%)', width: 800, height: 800, background: 'radial-gradient(circle, rgba(0,214,143,0.05) 0%, transparent 60%)', pointerEvents: 'none' }} />
      <div className="container">
        <div ref={addReveal} style={{ ...revealStyle, textAlign: 'center', maxWidth: 600, margin: '0 auto 72px', position: 'relative' }}>
          <span className="section-label">Como funciona</span>
          <h2 className="serif s-title" style={{ fontSize: '2.8rem', marginBottom: 16, color: '#fff' }}>Simples como deveria ser</h2>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '1.1rem' }}>Em 3 passos, você apresenta ao cliente o melhor cenário de financiamento</p>
        </div>
        <div className="g3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 40 }}>
          {STEPS.map((s, i) => (
            <div key={i} ref={addReveal} style={{ ...revealStyle, transitionDelay: `${0.1 * (i + 1)}s`, textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(0,214,143,0.1)', border: '1.5px solid rgba(0,214,143,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: '1.2rem', fontWeight: 700, color: 'var(--accent)' }}>{s.num}</div>
              <h3 style={{ fontSize: '1.15rem', fontWeight: 600, marginBottom: 12 }}>{s.title}</h3>
              <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.65, maxWidth: 280, margin: '0 auto' }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
